<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M14 4L10 4V6L14 6V4ZM6 5L9 5V6C9 6.55228 9.44772 7 10 7L14 7C14.5523 7 15 6.55228 15 6V5H18C18.5523 5 19 5.44772 19 6V15.1716C19 15.702 18.7893 16.2107 18.4142 16.5858L16.5858 18.4142C16.2107 18.7893 15.702 19 15.1716 19H6C5.44771 19 5 18.5523 5 18L5 6C5 5.44772 5.44772 5 6 5ZM8 10.75C8 10.3358 8.33579 10 8.75 10L15.25 10C15.6642 10 16 10.3358 16 10.75C16 11.1642 15.6642 11.5 15.25 11.5L8.75 11.5C8.33579 11.5 8 11.1642 8 10.75ZM8 14.25C8 13.8358 8.33579 13.5 8.75 13.5L12.25 13.5C12.6642 13.5 13 13.8358 13 14.25C13 14.6642 12.6642 15 12.25 15L8.75 15C8.33579 15 8 14.6642 8 14.25Z"
    fill="currentColor"
  />
</template>
